import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ApiService } from '@shared/catalogue/services/api.service';
import { Urls } from '../../../../utils/catalogue/urls';
import { DATA_PER_PAGE, File_deleted, CANCEL } from '@root/app.constant';
import { ToastrService } from 'ngx-toastr';
import { CommonDataService } from '@root/shared/catalogue/services/common-data.service';

@Component({
  selector: 'app-catalog-investor-process',
  templateUrl: './catalog-investor-process.component.html',
  styleUrls: ['./catalog-investor-process.component.scss'],
})
export class CatalogInvestorProcessComponent implements OnChanges {
  @Input() data: any[];

  investorProcessPDFsData = [];

  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.filterPdf(this.data);
    }
  }

  getDocs = () => {
    this.apiService.getData(Urls.getSectionDocs).subscribe((response: any) => {
      this.filterPdf(response.data.list);
    });
  };

  public filterPdf(data: any[]) {
    const investorProcessPDFsData = data.filter((pdf) => {
      return pdf.type === 'Process' || pdf.type === '8';
    });

    this.investorProcessPDFsData = [...investorProcessPDFsData];
  }

  public viewFile(path) {
    window.open(path, '_blank');
  }

  public deleteData(id) {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSectionDocuments, { id })
            .subscribe((response: any) => {
              this.toastr.success(File_deleted);
              this.getDocs();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  }
}
